import React from 'react';

import {
  Wrapper,
  IconContainer,
  MainContainer,
  SelectContainer,
  IconWhatsapp,
  GlobalStyle,
} from './styles';

interface Contact {
  info: string;
  select?: ISelect;
  selectFunction: Function;
  onkeypress: Function;
  isSelected: boolean;
}

const UseContactPhone: React.FC<Contact> = ({
  info,
  select,
  selectFunction,
  onkeypress,
  isSelected,
}) => {
  return (
    <Wrapper
      tabIndex={0}
      className={isSelected ? 'selected' : ''}
      onClick={() => selectFunction('whatsapp', select?.typeContact)}
      onKeyPress={(e) => onkeypress(e)}
    >
      <GlobalStyle />
      <IconContainer>
        <IconWhatsapp />
      </IconContainer>
      <MainContainer>
        <span className='info'>{info}</span>
      </MainContainer>
      <SelectContainer
        selected={isSelected}
        onClick={() => selectFunction('whatsapp', select?.typeContact)}
      >
        <span />
      </SelectContainer>
    </Wrapper>
  );
};

export default UseContactPhone;
